import {
  BusinessEntitlementConfig,
  EntitlementName,
} from "@shared/types/localTypes/entitlements.ts";

const entitlement: BusinessEntitlementConfig = {
  entitlementName: EntitlementName.COLD_STORAGE,
  displayName: "Cold Storage",
  isCustomerFacing: false,
};

export default entitlement;
